/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VerifyPayJunctionResponse
 */
export interface VerifyPayJunctionResponse {
    /**
     * 
     * @type {string}
     * @memberof VerifyPayJunctionResponse
     */
    transactionId: string;
    /**
     * 
     * @type {string}
     * @memberof VerifyPayJunctionResponse
     */
    status: string | null;
    /**
     * 
     * @type {string}
     * @memberof VerifyPayJunctionResponse
     */
    message: string | null;
}

/**
 * Check if a given object implements the VerifyPayJunctionResponse interface.
 */
export function instanceOfVerifyPayJunctionResponse(value: object): value is VerifyPayJunctionResponse {
    if (!('transactionId' in value) || value['transactionId'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function VerifyPayJunctionResponseFromJSON(json: any): VerifyPayJunctionResponse {
    return VerifyPayJunctionResponseFromJSONTyped(json, false);
}

export function VerifyPayJunctionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): VerifyPayJunctionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'transactionId': json['transactionId'],
        'status': json['status'],
        'message': json['message'],
    };
}

export function VerifyPayJunctionResponseToJSON(json: any): VerifyPayJunctionResponse {
    return VerifyPayJunctionResponseToJSONTyped(json, false);
}

export function VerifyPayJunctionResponseToJSONTyped(value?: VerifyPayJunctionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'transactionId': value['transactionId'],
        'status': value['status'],
        'message': value['message'],
    };
}

